import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Icon } from '../icon';
import { colorToken, OverrideContainer, useStyleProps } from '../utils';
import styles from './marker.module.css';
import { iconSize } from './consts';
/**
 * `<Marker/>` - Компонент маркер
 *
 * @example```tsx
 * <Marker variant="angular" text="Marker" />`
 * ```
 */
export const Marker = /*#__PURE__*/forwardRef(function Marker({
  variant,
  size = 's',
  iconLeft = null,
  iconRight = null,
  className,
  text,
  color = 'text-primary-invert',
  background = 'control-primary',
  'data-testid': testId = 'fronton-marker',
  borderColor,
  ...rest
}, ref) {
  const inlineStyles = useStyleProps({
    color,
    background,
    borderColor
  }, {
    color: ['--icon-color', colorToken],
    background: ['--background-color', colorToken],
    borderColor: ['--border-color', colorToken]
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: clsx(styles.marker, styles[variant], styles[size], className, {
      [styles.onlyText]: !iconLeft && !iconRight,
      [styles.onlyIcon]: iconLeft && !text,
      [styles.click]: rest.onClick || rest.onMouseEnter,
      [styles.noPadding]: background === 'transparent'
    }),
    role: "presentation",
    "data-testid": testId,
    ...inlineStyles,
    ...rest
  }, iconLeft && (/*#__PURE__*/React.createElement(OverrideContainer, {
    hard: {
      size: iconSize[size],
      type: 'outline',
      'data-testid': 'marker-iconleft'
    }
  }, /*#__PURE__*/React.createElement(Icon, null, iconLeft))), text && (/*#__PURE__*/React.createElement("span", {
    "data-testid": "marker-text",
    className: clsx(styles.markerText, styles[size], styles[variant], {
      [styles.onlyText]: !iconLeft && !iconRight,
      [styles.noPadding]: background === 'transparent' && !iconLeft && !iconRight
    })
  }, text)), iconRight && (/*#__PURE__*/React.createElement(OverrideContainer, {
    hard: {
      size: iconSize[size],
      type: 'outline',
      'data-testid': 'marker-iconright'
    }
  }, /*#__PURE__*/React.createElement(Icon, null, iconRight))));
});